export default __webpack_public_path__ + "static/media/merge-tag.028146af.svg";